import styled from 'styled-components';
import { motion } from 'framer-motion';

export const SplitHeroSection = styled.section`
  width: 100vw;
  overflow: hidden;
  background-color: ${({ bg }) => bg || '#fff'};
  padding: 9rem 0 6rem;

  @media (max-width: 768px) {
    padding: 7rem 0 3rem;
  }
`;

export const SplitHeroGrid = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

export const SplitHeroTextCol = styled.div``;

export const SplitHeroMediaCol = styled.div`
  position: relative;
`;

export const SplitHeroMedia = styled.video`
  width: 100%;
  height: 420px;
  object-fit: cover;
  border-radius: 20px;
  display: block;

  @media (max-width: 768px) {
    height: 280px;
  }
`;

export const SplitHeroImage = styled.img`
  width: 100%;
  height: 420px;
  object-fit: cover;
  border-radius: 20px;
  display: block;

  @media (max-width: 768px) {
    height: 280px;
  }
`;

export const FloatingBadge = styled(motion.div)`
  position: absolute;
  bottom: -1.5rem;
  left: -1.5rem;
  background: #000000;
  color: #ffffff;
  padding: 1.25rem 1.75rem;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    left: 1rem;
    bottom: -1rem;
    padding: 1rem 1.25rem;
  }
`;

export const FloatingBadgeNumber = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  color: #d1ff94;
  line-height: 1;
`;

export const FloatingBadgeLabel = styled.div`
  font-size: 0.75rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
`;

export const PlayButtonOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const PlayButtonCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  padding-left: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
`;
